// This React component, `GolfHolidaysDirectPage`, is a Next.js client component designed to render the Golf
// Holidays Direct landing page. It extracts data from the `dataSource` within the `data` prop and passes it
// to the `GolfHolidayDirect` component for display. By using `TasticProps<GolfHolidayDirectPage>`, it ensures
// type safety and structured data handling. This setup allows for efficient and dynamic content rendering for
//  the Golf Holidays Direct page.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import { GolfHolidayDirectPage } from 'types/next';
import GolfHolidayDirect from 'components/commercetools-ui/organisms/landing-pages/golf-holidays-direct';

const GolfHolidaysDirectPage = ({ data }: TasticProps<GolfHolidayDirectPage>) => {
  const golfHolidayDirect = data?.data?.dataSource;

  return (
    <>
      <GolfHolidayDirect golfHoliday={golfHolidayDirect} />
    </>
  );
};

export default GolfHolidaysDirectPage;
